import translationCommon from './common.json';

export const json = {
    "translation": translationCommon
}
